import { PureComponent } from 'react';

import { isNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import OverviewPropTypes from '../../../../OverviewPropTypes';

export default class AddToGroupArrow extends PureComponent {
  static propTypes = {
    onAdd: PropTypes.func.isRequired,
    reportsInGroup: OverviewPropTypes.reportsInGroup,
    selectedReport: PropTypes.string,
  };

  canAdd = () => {
    const { selectedReport, reportsInGroup } = this.props;
    if (isNullable(selectedReport)) {
      return false;
    }
    const foundIndex = reportsInGroup.findIndex(
      (child) => child.id === selectedReport,
    );
    if (foundIndex > -1) {
      return false;
    }
    return true;
  };

  render() {
    const { onAdd } = this.props;
    const canAdd = this.canAdd();
    return (
      <div className='dashboard-color-form__add-to-group-wrapper'>
        <i
          className={classNames(
            'fa fa-arrow-left',
            'dashboard-color-form__add-to-group-icon',
            canAdd && 'dashboard-color-form__add-to-group-icon--selected',
          )}
          onClick={canAdd ? onAdd : null}
        />
      </div>
    );
  }
}
